import React, { useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";

export default function Selector(props) {
  const {
    label,
    csvData = [],
    variant = "outlined",
    classes = "",
    onChange,
    previewMode = false,
    ...restProps
  } = props;
  const selectorRef = useRef(null);

  const handleChange = (event, value) => {
    if (value) {
      const touchedEvent = {
        ...event,
        target: {
          ...selectorRef.current,
          value: value.key,
        },
      };
      onChange(touchedEvent);
    }
  };

  return (
    <Autocomplete
      className={classes}
      options={csvData}
      disabled={csvData.length === 0}
      autoHighlight
      getOptionLabel={(option) => option.value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          {...restProps}
          ref={selectorRef}
          label={label}
          variant={variant}
        />
      )}
      disablePortal={previewMode}
    />
  );
}

Selector.propTypes = {
  classes: PropTypes.string,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  csvData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func,
  previewMode: PropTypes.bool,
};
